import { render, staticRenderFns } from "./CalendarEventDetail.vue?vue&type=template&id=5efb7b5f&"
import script from "./CalendarEventDetail.vue?vue&type=script&lang=js&"
export * from "./CalendarEventDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports